import { getTenantCreationRequests } from '@/lib/api-client';
import { useQuery } from '@tanstack/react-query';
import * as dtos from '@/lib/dtos';

export function useTenantCreationRequests() {
  return useQuery<dtos.TenantCreationRequest[]>({
    queryKey: ['tenant-creation-requests'],
    queryFn: getTenantCreationRequests,
  });
}
